import React from 'react';
import * as classes from './suggestionBlogCard.module.css';
import getDate from '../../../../../utils/getDate';
import getReadingTime from '../../../../../utils/getReadingTime';

function truncate(str, number_of_words) {
  return str.split(' ').splice(0, number_of_words).join(' ');
}

export default function SuggestionBlogCard({ blog }) {
  let blogDate = getDate(blog.date);

  function openNewLink() {
    let newWindow = window.open(blog.uri, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  }

  function handleClick() {
    openNewLink();
  }

  function handleKeyDown(ev) {
    if (ev.keyCode === 13) {
      openNewLink();
    }
  }

  return (
    <div className={classes.card}>
      <div
        onClick={() => openNewLink()}
        onKeyDown={(ev) => handleKeyDown(ev)}
        role="button"
        tabIndex={0}
        className={classes.image_link}
      >
        <div className={classes.category_tag}>
          <p className={classes.category_text}>
            {blog.categories.nodes[0].name}
          </p>
        </div>
        <img
          alt={blog.featuredImage?.node?.altText || blog.slug}
          src={
            blog.featuredImage?.node?.mediaItemUrl ||
            'https://www.zomato.com/blog/wp-content/uploads/2021/06/EV100-blog-2-1-2048x1072.png'
          }
          className={`${classes.image} animate`}
        />
      </div>
      <div className={`${classes.content} ${classes.padding_zero}`}>
        <div className={`text-font-family ${classes.blog_date}`}>
          <span style={{ fontWeight: 'bold' }}>{blog.author.node.name}</span>
          {` | ${blogDate} | `}
          <span>{getReadingTime(blog.content)}</span>
        </div>
        <div
          onClick={() => handleClick()}
          onKeyDown={(ev) => handleKeyDown(ev)}
          role="button"
          tabIndex={0}
          className={`text-font-family ${classes.blog_title} ${classes.content_space}`}
        >
          {blog.title}
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: truncate(blog.excerpt, 50) }}
          className={`text-font-family ${classes.blog_content} ${classes.content_space}`}
        />
      </div>
    </div>
  );
}
